export default "__VITE_ASSET__C1XePu7E__"